import { styled } from 'src/ui/theme'

export const Flex1 = styled.div`
  display: flex;
  flex: 1;
`
